var app = app ||  {};
app.cliente = app.cliente || {};

;(function(namespace, $){

  var Cliente = function() {

    function CadastraCliente() {
      var validate_form = new lcssafira.form.ValidateForm('form-cliente');
    }

    function BuscaCliente() {
      $('#form-busca-cliente').submit(function(event) {
        event.preventDefault();
        var data = $(this).serialize();
        app.datatable.initDataTable(true, false, '?' + data, 'cliente', '/cliente/consultar');
      });
    }

    function listenerCheckPessoa() {
      $('#tipo-pessoa').on('switchChange.bootstrapSwitch', function(event, state) {
          showInputsPessoa(state);
      });
    }

    function showInputsPessoa(state) {
      
      if(state) {
        $('.pj').removeClass('hide');
        $('.pf').addClass('hide');
      }
      else {
        $('.pj').addClass('hide');
        $('.pf').removeClass('hide');
      }
    }

    function abreCliente() {
      $('table').on('click', '.cliente-col', function(event) {
        event.preventDefault();
        id_cliente = $(this).parents('tr').find('.cod').text();
        app.ajaxrequest.initialize('/cliente/consultar/' + id_cliente, 'get', 'json', '', app.cliente.responseCliente);
      });
    }

    function responseCliente(data) {
      var holder_contatos;

      holder_contatos = $('#holder-contatos');
      holder_contatos.html('');

      $('.bd-holder').each(function(index, el) {
        column = $(this).attr('data-column');

        if(data[0][column] == '' || data[0][column] == null)
          $(el).text('n/d');
        else
          $(el).html(data[0][column]);
      });

      $.each(data[0]['contatos_cliente'], function(index, val) {

        if(val.tel_contato_cliente != '' || val.tel_contato_cliente != 'n/d')
          tel_cliente = app.main.formatTel(val.tel_contato_cliente);
        else
          tel_cliente = 'n/d';

        if(val.cel_contato_cliente != '' || val.cel_contato_cliente != 'n/d')
          cel_cliente = app.main.formatTel(val.cel_contato_cliente);
        else
          cel_cliente = 'n/d';

         holder_contatos.append(
          '<span class="block small">Contato: ' + val.nome_contato_cliente + '</span>' + 
          '<span class="block small">Tel.: ' + tel_cliente + '</span>' + 
          '<span class="block small">Cel.: ' + cel_cliente + '</span>' + 
          '<span class="block small">E-mail: ' + val.email_contato_cliente + '</span>'
          );
      });

      $('#modal-cliente').modal();
    }

    function _construct() {
      CadastraCliente();
      BuscaCliente();
      listenerCheckPessoa();
      abreCliente();

      app.datatable.initDataTable(false, true, '', 'cliente', '/cliente/consultar');
      var message = "A remoção de um cliente implica na exclusão de qualquer dado vinculado a ele.";
      var confirm_modal = new lcssafira.confirmmodal.ConfirmModal('.remove-cliente', message);
    }

    namespace.responseCliente = responseCliente;
    _construct();

  };

  var main = new Cliente();

})(app.cliente, jQuery);


